import { ThirdPartyEvaluationFormItem } from './thirdparty-evaluation-form-item';

export class ThirdPartyEvaluationForm {
    id: number = 0;
    description: string = '';
    canInitConversation: boolean = false;

    appFormItems: ThirdPartyEvaluationFormItem[] = [new ThirdPartyEvaluationFormItem()];

    constructor() {
    }
}
